<template>
  <div class="container-fluid basket">
    <div class="row">
      <div class="col-sm-2 col-12">
        <a
                class="p-2 text-white float-left mt-2 col-12 userName"
                @click="clearCartSection"
        >
          {{ this.name.toUpperCase() }}
        </a>
      </div>
      <div class="col-sm-4 col-sm-10 col-12 ml-lg-auto header-bottom ">
        <div class="float-right parent-links">
          <small>
            {{ $t('customer.currentAddress') }}
            <span v-if="currentShipping">
          {{ currentShipping.addressName}}
          </span>
            <span v-else>
          {{ $t('customer.selectCustomer') }}
          </span>
          </small>
          <small>
            {{ $t('customer.basket') }}
            <span
                    v-if="itemCount > 0"
            >
          {{ itemCount }} {{ $t('orders.elements') }} {{ currencyDisplay(totalPrice, false) }}
        </span>
            <span v-else>
          {{ $t('orders.empty') }}
        </span>
          </small>
          <div class=" shopping-cart" aria-hidden="true">
            <router-link
                    to="/cart"
                    class="btn btn-sm bg-white text-white basket"
                    :style="{ backgroundImage: 'url(' + require('@/assets/icon.jpg') + ')'} "
                    :disabled="itemCount === 0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { currencyMixin } from '../mixins';
export default {
  name: 'CartSummary',
  mixins: [currencyMixin],
  data: function() {
    return {
      name: '',
      companyName: ''
    };
  },
  computed: {
    ...mapGetters('cart', [
      'itemCount',
      'totalPrice',
      'currentCustomer',
      'currentShipping'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
  },
  mounted() {
    this.name = this.user.firstname + " " + this.user.lastname;
    this.companyName = ""
  },
  methods: {
    clearCartSection() {
      this.$store.commit("setCartData", []);
      localStorage.removeItem("cart");
    }
  }
};
</script>
